export default {
  props: {
    token: {
      type: String,
      required: null,
    },
    id: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: true,
      errors_activated: false,
      signature: null
    }
  },
  computed: {
    hasError () {
      return false;
    },
    readonly () {
      return this.id !== null
    }
  },
  methods: {
    input_state (key) {
      return this.$v[key]?.$invalid && this.errors_activated ? false : null
    },
    formular_text (key) {
      return this.$t(`formular.${this.formular_key}.${key}`)
    },
    isSigned (signature) {
      let base64Indicator = "data:image/png;base64,"
      if (signature === undefined) {
        return this.signature !== null && !this.signature.startsWith(base64Indicator);
      }
      return signature !== null && !signature.startsWith(base64Indicator);
    },
  }
}
